import { Injectable } from '@angular/core';
import { Thutuchanhchinh } from '../model/quanlythongtin/thutuchanhchinh';
import { Donvitructhuoc } from '../model/quanlythongtin/dmdonvitructhuoc';
import { DattaConfig } from '../app-config';
import { HttpClient, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { from } from 'rxjs';
import { QlttLinhVuc } from '../model/quanlythongtin/QlttLinhVuc';
import { Quanlylichhop } from '../model/quanlythongtin/quanlylichhop';
import { Observable } from 'rxjs/Rx';
import { ThongtinDetai } from '../model/thongtindetai/thongtindetai';
import { ThongtindetaiLinhVuc } from '../model/thongtindetai/thongtindetailinhvuc';
import { ThongtindetaiCoquanchutri } from '../model/thongtindetai/thongtindetaicoquanchutri';
import { Quanlyhoidap } from '../model/quanlythongtin/quanlyhoidap';
import { QuanlyhoidapChitiet } from '../model/quanlythongtin/quanlyhoidapchitiet';
import { Thongtinvanban } from '../model/quanlyvanban/thongtinvanban';
import { ThongtinvanbanFiledinhkem } from '../model/quanlyvanban/thongtinvanbanFiledinhkem';
import { Coquanbanhanh } from '../model/quanlyvanban/coquanbanhanh';
import { Linhvuc } from '../model/quanlyvanban/linhvuc';
import { Loaivanban } from '../model/quanlyvanban/loaivanban';
import { Nguoiky } from '../model/quanlyvanban/nguoiky';
import { Dscauhoi } from '../model/quanlythongtin/dscauhoi';
import { DscauhoiTraloi } from '../model/quanlythongtin/dscautraloi';
import { Hoidap } from '../model/quanlythongtin/hoidap';
import { Donvi } from '../model/quanlythongtin/donvi';
import { Lienhe } from '../model/quanlythongtin/lienhe';
import { Dmlinhvucgopy } from '../model/quanlythongtin/dmlinhvucgopy';
import { Congkhaingansach } from '../model/quanlythongtin/congkhaingansach';
import { Duanvbqppl } from '../model/quanlythongtin/duanvbqppl';
import { DuanvbqpplGopy } from '../model/quanlyvanban/duanvbqpplgopy';
import { Diendancutri } from '../model/quanlyvanban/diendancutri';
import { DmlinhvucDadt } from '../model/quanlythongtin/dmlinhvucdadt';
import { DmhuyenthiDadt } from '../model/quanlythongtin/dmhuyenthidadt';
import { Duankeugoidautu } from '../model/quanlythongtin/duankeugoidautu';
import { Giaiquyetdonthukntc } from '../model/quanlythongtin/giaiquyetdonthukntc';
import { Quanlyhoidaptructuyen } from '../model/quanlythongtin/quanlyhoidaptructuyen';


@Injectable({
  providedIn: 'root'
})
export class LayoutsService {
  public dattaConfig: any;

  constructor(private httpClient: HttpClient) {
    this.dattaConfig = DattaConfig.config;
  }

  getDsTTHC(madv) {
    return this.httpClient.get<Thutuchanhchinh[]>(this.dattaConfig['httplink'] + '/layout/tthc/' + madv);
  }

  getTTHCDonvitructhuoc(madv) {
    return this.httpClient.get<Donvitructhuoc[]>(this.dattaConfig['httplink'] + '/layout/dvtt/' + madv);
  }

  getTTHCLinhVuc(madv) {
    return this.httpClient.get<QlttLinhVuc[]>(this.dattaConfig['httplink'] + '/layout/linhvuc/' + madv);
  }

  getLichHops(ngay: string, madv: string) {
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + '/layout/lichhop/' + ngay + '/' + madv);
  }

  getLichHopCaTuans(tungay: string, denngay: string, madv: string) {
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + '/layout/lichhop/' + tungay + '/' + denngay + '/' + madv);
  }

  searchTTHCs(params: any) {
    let pars = { params };
    return this.httpClient.get<Thutuchanhchinh[]>(this.dattaConfig['httplink'] + `/layout/tthc/search`, pars);
  }
  
  //Đang xài
  uploadfile(file: File, folder: string) {
    return new Promise(resolve => {
      const formData: FormData = new FormData();
      formData.append('file', file);
      formData.append('folder', folder);
      const req = new HttpRequest('POST', this.dattaConfig['httplink'] + '/layout/upload', formData, {
        responseType: 'json'
      });
      this.httpClient.request(req).subscribe(event => {
        if (event instanceof HttpResponse) {
          resolve(event.body);
        }
      }, err => {
        resolve(null);
      });
    });
  }

  //Đang xài
  public getURLFile(filename: any, folder: string) {
    return this.httpClient.get(this.dattaConfig['httplink'] + '/layout/download/' + folder + '/' + filename,
      {
        observe: 'response',
        responseType: 'blob'
      },
    )
      .map((res) => {
        //console.log(res);
        let data = {
          image: new Blob([res.body], { type: res.headers.get('Content-Type') }),
          filename: res.headers.get('File-Name')
        }
        return data;
      }).catch((err) => {
        return Observable.throw(err);
      });

  }

  getThongtinDetais(madv: string, ...field: any) {
    //field[0]: Nam
    //field[1]: Linh vuc
    //field[2]: Cap
    //field[3]: don vi chu quan
    //field[4]: keysearch
    let pars = {
      params: {
        yearsearch: field[0] === undefined ? '' : field[0],
        fieldsearch: field[1] === undefined ? '' : field[1],
        levelsearch: field[2] === undefined ? '' : field[2],
        organizationsearch: field[3] === undefined ? '' : field[3],
        keysearch: field[4] === undefined ? '' : field[4]
      }
    };

    return this.httpClient.get<ThongtinDetai[]>(this.dattaConfig['httplink'] + `/layout/thongtindetai/${madv}`, pars);
  }

  getThongtindetaiLinhVucs() {
    return this.httpClient.get<ThongtindetaiLinhVuc[]>(this.dattaConfig['httplink'] + '/layout/thongtindetailinhvuc');
  }

  getThongtindetaiCoquanchutris() {
    return this.httpClient.get<ThongtindetaiCoquanchutri[]>(this.dattaConfig['httplink'] + '/layout/thongtindetaicoquanchutri');
  }

  getExportLichHops(tungay: string, denngay: string, madv: string, type: string) {

    return this.httpClient.get(this.dattaConfig['httplink'] + '/layout/export/' + tungay + '/' + denngay + '/' + madv + '/' + type,
      {
        observe: 'response',
        responseType: 'blob'
      },
    )

  }

  getExportLichHopNgays(ngay: string, madv: string, type: string) {

    return this.httpClient.get(this.dattaConfig['httplink'] + '/layout/exportday/' + ngay + '/' + madv + '/' + type,
      {
        observe: 'response',
        responseType: 'blob'
      },
    )

  }


  getLichTiepDanThangs(nam: number, thang: number, madv: string) {
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + '/layout/tiepcongdan/' + nam + '/' + thang + '/' + madv);
  }

  getLichTiepDanNams(nam: number, madv: string) {
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + '/layout/tiepcongdan/' + nam + '/' + madv);
  }

  getHoiDaps(madv: string) {
    return this.httpClient.get<Quanlyhoidaptructuyen[]>(this.dattaConfig['httplink'] + `/layout/quanlyhoidaptructuyen/${madv}`);
  }

  addLayoutHoiDap(entity: Quanlyhoidaptructuyen,madv: string) {
    return this.httpClient.post<Quanlyhoidaptructuyen>(this.dattaConfig['httplink'] + `/layout/quanlyhoidaptructuyen/add/${madv}`, entity);
  }

  getHoiDapChiTiets(id) {
    return this.httpClient.get<QuanlyhoidapChitiet[]>(this.dattaConfig['httplink'] + '/layout/quanlyhoidapchitiet/' + id);
  }

  getThongtinvanbans(madv: string, capvb: string, loaivb: string, ...field: any) {
    let pars = {
      params: {
        searchtungay: field[0] === undefined ? '' : field[0],
        searchdenngay: field[1] === undefined ? '' : field[1],
        searchcoquan: field[2] === undefined ? '' : field[2],
        searchlinhvuc: field[3] === undefined ? '' : field[3],
        searchloaivanban: field[4] === undefined ? '' : field[4],
        searchnguoiky: field[5] === undefined ? '' : field[5],
        searchtukhoa: field[6] === undefined ? '' : field[6],
        searchtrichyeu: field[7] === undefined ? '' : field[7]
      }
    };
    return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanban/${madv}/${capvb}/${loaivb}`, pars);
    //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
  }

  getThongtinvanbansTheoNam(madv: string, capvb: string, loaivb: string, namvb: string, coquanbhvb: string, ...field: any) {
    let pars = {
      params: {
        searchtungay: field[0] === undefined ? '' : field[0],
        searchdenngay: field[1] === undefined ? '' : field[1],
        searchcoquan: field[2] === undefined ? '' : field[2],
        searchlinhvuc: field[3] === undefined ? '' : field[3],
        searchloaivanban: field[4] === undefined ? '' : field[4],
        searchnguoiky: field[5] === undefined ? '' : field[5],
        searchtukhoa: field[6] === undefined ? '' : field[6],
        searchtrichyeu: field[7] === undefined ? '' : field[7]
      }
    };
    return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanbantheonam/${madv}/${capvb}/${loaivb}/${namvb}/${coquanbhvb}`, pars);
    //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
  }

  getThongtinvanbanmoinhats(madv: string, capvb: string, loaivb: string, soluong: string) {
     return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanbanmoinhat/${madv}/${capvb}/${loaivb}/${soluong}`);
    //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
  }

  getThongtinvanbanTheoid(id: number) {
    return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + `/layout/getvanbantheoid/${id}`);
   //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
 }

  getFilterVBs(madv: string, capvb: string, loaivb: string, ...field: any) {
    let pars = {
      params: {
        searchtukhoa: field[0] === undefined ? '' : field[0]
        
      }
    };
    return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanban/search/${madv}/${capvb}/${loaivb}`, pars);
    //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
  }

  getFilterVBsTheoNam(madv: string, capvb: string, loaivb: string, namvb: string, ...field: any) {
    let pars = {
      params: {
        searchtukhoa: field[0] === undefined ? '' : field[0]
        
      }
    };
    return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanbantheonam/search/${madv}/${capvb}/${loaivb}/${namvb}`, pars);
    //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
  }


  getThongtinvanbanFiledinhkems(id: number) {
    return this.httpClient.get<ThongtinvanbanFiledinhkem[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanban/thongtinvanbanFiledinhkem/${id}`);
  }

  getCoquanbanhanhs(madv: string) {
    return this.httpClient.get<Coquanbanhanh[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanban/dmcoquanbanhanh/${madv}`);
  } 
  

  getLinhvucs(madv: string) {
    return this.httpClient.get<Linhvuc[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanban/dmlinhvuc/${madv}`);
  }
 
 


  getLoaivanbans(madv: string) {
    return this.httpClient.get<Loaivanban[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanban/dmloaivanban/${madv}`);
  }

  getNguoikys(madv: number) {
    return this.httpClient.get<Nguoiky[]>(this.dattaConfig['httplink'] + `/layout/coquanbanhanh/dmnguoiky/${madv}`);
  }

  getNguoikysTheoDV(madv: string) {
    return this.httpClient.get<Nguoiky[]>(this.dattaConfig['httplink'] + `/layout/thongtinvanban/dmnguoiky/${madv}`);
  }

  getExportLichTiepDanThangs(nam: number, thang: number, madv: string, type: string) {

    return this.httpClient.get(this.dattaConfig['httplink'] + '/layout/exporttiepdanthang/' + nam + '/' + thang + '/' + madv + '/' + type,
      {
        observe: 'response',
        responseType: 'blob'
      },
    )

  }

  getExportLichTiepDanNams(nam: number, madv: string, type: string) {

    return this.httpClient.get(this.dattaConfig['httplink'] + '/layout/exporttiepdannam/' + nam + '/' + madv + '/' + type,
      {
        observe: 'response',
        responseType: 'blob'
      },
    )

  }


  //cau hoi tham do

  getCauhoi(madv: string) {
    return this.httpClient.get<Dscauhoi[]>(this.dattaConfig['httplink'] + `/layout/cauhoithamdo/${madv}`);
  }
  getDscautraloi(id) {
    return this.httpClient.get<DscauhoiTraloi[]>(this.dattaConfig['httplink'] + `/layout/cauhoithamdo/gettraloi/${id}`);
  }

  updateDscautraloi(id) {
    return this.httpClient.post<DscauhoiTraloi>(this.dattaConfig['httplink'] + '/layout/cauhoithamdo/updatecautraloi', id);
  }

  //gop y
  getHoidaps(madv: string, sort: boolean) {
    let pars = {
      params: {
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Hoidap[]>(this.dattaConfig['httplink'] + `/layout/hoidap/${madv}`, pars);
  }

  getHoidapByHienKes(madv: string, sort: boolean,loai: string) {
    let pars = {
      params: {
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Hoidap[]>(this.dattaConfig['httplink'] + `/layout/hoidap/${madv}/${loai}`, pars);
  }

  addHoidap(entity: Hoidap) {
    return this.httpClient.post<Hoidap>(this.dattaConfig['httplink'] + '/layout/hoidap/add', entity);
  }

  getHoidapSearch(madv: string, ...field: any) {
    let pars = {
      params: {
        searchtukhoa: field[0] === undefined ? '' : field[0],
        searchtungay: field[1] === undefined ? '' : field[1],
        searchdenngay: field[2] === undefined ? '' : field[2],
        searchlinhvuc: field[3] === undefined ? '' : field[3]
      }
    };
    return this.httpClient.get<Hoidap[]>(this.dattaConfig['httplink'] + `/layout/hoidap/search/${madv}`, pars);
    //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
  }

  getDonVi(madv: string) {
    return this.httpClient.get<Donvi>(this.dattaConfig['httplink'] + `/layout/dmdonvi/${madv}`);
  }

  getLienhes(madv: string, sort: boolean) {
    let pars = {
      params: {
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Lienhe[]>(this.dattaConfig['httplink'] + `/layout/lienhe/${madv}`, pars);
  }

  addLienhe(entity: Lienhe) {
    return this.httpClient.post<Lienhe>(this.dattaConfig['httplink'] + '/layout/lienhe/add', entity);
  }

  getLinhvucgopy(madv: string) {
    return this.httpClient.get<Dmlinhvucgopy>(this.dattaConfig['httplink'] + `/layout/linhvucgopy/${madv}`);
  }
  getCongkhaingansachs(madv: string, type: string, sort: boolean, ...field: any) {
    let pars = {
      params: {
        soqd: field[0] === undefined ? '' : field[0],
        kyhieu: field[1] === undefined ? '' : field[1],
        searchtungay: field[2] === undefined ? '' : field[2],
        searchdenngay: field[3] === undefined ? '' : field[3],
        nam: field[4] === undefined ? '' : field[4],
        tenbaocao: field[5] === undefined ? '' : field[5],
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Congkhaingansach[]>(this.dattaConfig['httplink'] + `/layout/congkhaingansach/${madv}/${type}`, pars);
  }

  getcongkhaingansachtheoid(id: string) {
    return this.httpClient.get<Congkhaingansach>(this.dattaConfig['httplink'] + `/layout/getcknstheoid/${id}`);
  }
  congkhaingansachexport(madv: string, type: string, exporttype: string, sort: boolean, ...field: any) {
    return this.httpClient.get(this.dattaConfig['httplink'] + `/layout/congkhaingansachexport/${madv}/${type}/${exporttype}`, {
      params: {
        soqd: field[0] === undefined ? '' : field[0],
        kyhieu: field[1] === undefined ? '' : field[1],
        searchtungay: field[2] === undefined ? '' : field[2],
        searchdenngay: field[3] === undefined ? '' : field[3],
        nam: field[4] === undefined ? '' : field[4],
        tenbaocao: field[5] === undefined ? '' : field[5],
        sort: sort ? 'asc' : 'desc'
      },
      observe: 'response',
      responseType: 'blob'
    });
  }

  getDuthaovanbansDangLayYKien(madv: string, pageno: number, pagesize: number, sort: boolean, ...field: any) {
    let pars = {
      params: {
        tinhtrang: field[0] === undefined ? '' : field[0],
        pageno: pageno+'',
        pagesize: pagesize+'',
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Duanvbqppl[]>(this.dattaConfig['httplink'] + `/layout/duthaovbqppl/danglayykien/${madv}`, pars);
  }

  getDuthaovanbansHetHanLayYKien(madv: string, pageno: number, pagesize: number, sort: boolean) {
    let pars = {
      params: {
        pageno: pageno+'',
        pagesize: pagesize+'',
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Duanvbqppl[]>(this.dattaConfig['httplink'] + `/layout/duthaovbqppl/hethanlayykien/${madv}`, pars);
  }

  getDuthaovbtheoID(id) {
    return this.httpClient.get<Duanvbqppl>(this.dattaConfig['httplink'] + `/layout/duthaovbqppl/` + id);
  }
  addGopy(entity: DuanvbqpplGopy) {
    return this.httpClient.post<DuanvbqpplGopy>(this.dattaConfig['httplink'] + '/layout/duthaogopy/add', entity);
  }

  getGopys(id: number, sort: boolean, ...field: any) {
    let pars = {
      params: {
        tinhtrang: field[0] === undefined ? '' : field[0],
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<DuanvbqpplGopy[]>(this.dattaConfig['httplink'] + `/layout/duthaogopy/getbyduthao/${id}`, pars);
  }

  getLayYKNhandansDangLayYKien(madv: string, pageno: number, pagesize: number, sort: boolean, ...field: any) {
    let pars = {
      params: {
        tinhtrang: field[0] === undefined ? '' : field[0],
        pageno: pageno+'',
        pagesize: pagesize+'',
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Duanvbqppl[]>(this.dattaConfig['httplink'] + `/layout/layykiennhandan/danglayykien/${madv}`, pars);
  }

  getLayYKNhandansHetHanLayYKien(madv: string, pageno: number, pagesize: number, sort: boolean) {
    let pars = {
      params: {
        pageno: pageno+'',
        pagesize: pagesize+'',
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Duanvbqppl[]>(this.dattaConfig['httplink'] + `/layout/layykiennhandan/hethanlayykien/${madv}`, pars);
  }

  getDiendancutri(madv: string, sort: boolean) {
    let pars = {
      params: {
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Diendancutri[]>(this.dattaConfig['httplink'] + `/layout/diendancutri/${madv}`, pars);
  }
  addDiendancutri(entity: Diendancutri) {
    return this.httpClient.post<Diendancutri>(this.dattaConfig['httplink'] + '/layout/diendancutri/add', entity);
  }

  searchDiendancutri(madv: string, ...field: any) {
    let pars = {
      params: {
        searchtukhoa: field[0] === undefined ? '' : field[0],
        searchtungay: field[1] === undefined ? '' : field[1],
        searchdenngay: field[2] === undefined ? '' : field[2]
      }
    };
    return this.httpClient.get<Diendancutri[]>(this.dattaConfig['httplink'] + `/layout/diendancutri/search/${madv}`, pars);
    //return this.httpClient.get<Thongtinvanban[]>(this.dattaConfig['httplink'] + '/layout/thongtinvanban/' + madv + '/' + capvb, pars);
  }

  getGiaiQuyetDonThuKntcs(madv: string, sort: boolean, ...field: any) {
    let pars = {
      params: {
        tungay: field[0] === undefined || field[0] === null ? '' : field[0],
        denngay: field[1] === undefined || field[1] === null ? '' : field[1],
        loaidonthu: field[2] === undefined || field[2] === null ? '' : field[2],
        hoten: field[3] === undefined || field[3] === null ? '' : field[3],
        dmdiabanid: field[4] === undefined || field[4] === null ? '' : field[4],
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Giaiquyetdonthukntc[]>(this.dattaConfig['httplink'] + `/layout/giaiquyetdonthukntc/search/${madv}`, pars);
  }

  getFilterDonThuKntcs(madv: string, sort: boolean, ...field: any) {
    let pars = {
      params: {
        tukhoa: field[0] === undefined || field[0] === null ? '' : field[0],        
        sort: sort ? 'asc' : 'desc'
      }
    };
    return this.httpClient.get<Giaiquyetdonthukntc[]>(this.dattaConfig['httplink'] + `/layout/giaiquyetdonthukntc/searchfilter/${madv}`, pars);
  }

  getDmhuyenthiDadts() {
    return this.httpClient.get<DmhuyenthiDadt[]>(this.dattaConfig['httplink'] + '/layout/huyenthidadt');
  }

  getLinhvucdadt(madv: string) {
    return this.httpClient.get<DmlinhvucDadt>(this.dattaConfig['httplink'] + `/layout/linhvucdadt/${madv}`);
  }
  getDiadiemdadt() {
    return this.httpClient.get<DmhuyenthiDadt>(this.dattaConfig['httplink'] + `/layout/huyenthidadt`);
  }
  getDuandautu(madv: string, ...field: any) {
    let pars = {
      params: {
        searchtenduan: field[0] === undefined ? '' : field[0],
        searchlinhvuc: field[1] === undefined ? '' : field[1],
        searchhuyenthi: field[2] === undefined ? '' : field[2],
        searchtungay: field[3] === undefined ? '' : field[3],
        searchdenngay: field[4] === undefined ? '' : field[4],
        searchkinhphi: field[5] === undefined ? '' : field[5],
        searchtinhtrang: field[6] === undefined ? '' : field[6],
        searchdiachi: field[7] === undefined ? '' : field[7],
        
      }
    };
    return this.httpClient.get<Duankeugoidautu[]>(this.dattaConfig['httplink'] + `/layout/duandautu/search/${madv}`, pars);
  }

  searchDuandaututrongdiems(params: any) {
    let pars = { params };
    return this.httpClient.get<Duankeugoidautu[]>(this.dattaConfig['httplink'] + `/layout/duandaututrongdiem/search`, pars);
  }

}
